module.exports = __webpack_public_path__ + "static/img/bg-8.6a8e680.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/history-bg/bg-8.png
// module id = sUyi
// module chunks = 0